import { render, staticRenderFns } from "./OnlineCreate.vue?vue&type=template&id=524fe877&"
import script from "./OnlineCreate.vue?vue&type=script&lang=js&"
export * from "./OnlineCreate.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports